import { Loading } from '@/components/ui';

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({
  message = 'Loading survey...',
}: LoadingScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loading size="lg" message={message} />
      </div>
    </div>
  );
}
